module.exports = __webpack_public_path__ + "VIPV5.png?51e4aebf9db2edfdcf51fd95232db38b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV5.png
// module id = 138
// module chunks = 0